import axios from 'axios';
import router from "@/router";
import {message} from "ant-design-vue";
export const baseUrl = 'https://study.gdhjxhjxjy.cn';
// const baseUrl = 'http://study.com/api';
//跳转外部页面
export const goWebUrl = (url,black = true) =>{
    if(black){
        window.open(url,'_blank');
    }else{
        location.href = url;
    }
}
//跳转页面
export const goUrl = (url) =>{
    if(url){
        router.push(url);
    }
}
//更新用户缓存信息
export const setUser = (newUser) =>{
    let user =JSON.parse(sessionStorage.getItem('user'));
    for (const key in user) {
        if(Object.keys(newUser).includes(key)){
            user[key] = newUser[key];
        }
    }
    sessionStorage.setItem('user', JSON.stringify(user));
}
/**请求API(使用示例)
 * import {getRequest} from '@/assets/js/common';
 * getRequest('/banner', { type: 1 })
 *     .then(res => {
 *       console.log('res', res);
 *     }).catch(error => {
 *     }).finally(() => {
 *     });
 */
export const getRequest = (url, data = {}, method = 'POST', isFileUpload = false) => {
    const config = {
        headers: {
            'X-Client-Type': 'pc',
            'Content-Type': isFileUpload ? 'multipart/form-data' : 'application/json',
            'token':sessionStorage.getItem('token'),
        },
    };
    // 拼接 baseUrl
    const fullUrl = /^https?:\/\//.test(url) ? url : `${baseUrl}/api${url}`;

    // 判断是否是文件上传请求
    if (isFileUpload) {
        // 使用 FormData 来封装文件数据
        const formData = new FormData();
        formData.append('file', data.file['file']);
        return axios.post(fullUrl, formData, config)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                // 错误处理
                return { error: '请求失败', details: err.response ? err.response.data : err.message };
            });
    }

    // 请求类型判断
    method = method.toUpperCase();
    if (method === 'GET') {
        config.params = data;
        return axios.get(fullUrl, config)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                // 错误处理
                return { error: '请求失败', details: err.response ? err.response.data : err.message };
            });
    } else if (method === 'POST') {
        return axios.post(fullUrl, data, config)
            .then(res => {
                return res.data;
            })
            .catch(err => {
                console.log('catch',err)
                // 错误处理
                return { error: '请求失败', details: err.response ? err.response.data : err.message };
            });
    }
    // 如果传入的 method 不合法
    return Promise.reject(new Error('请求失败'));
}
export const downloadFile = (fileUrl, method = 'POST') => {
    if (!fileUrl) {
        console.error('文件 URL 不能为空');
        return;
    }

    // 解析文件名（获取 URL 最后一部分，并去掉查询参数）
    const filename = decodeURIComponent(fileUrl.split('/').pop().split('?')[0]) || 'downloaded_file';

    const config = {
        headers: {
            'token': sessionStorage.getItem('token'),
        },
        responseType: 'blob'
    };

    // 发送请求的方法
    let request;

    // 统一的请求 URL
    const requestUrl = `${baseUrl}/api/common/download`;

    if (method.toUpperCase() === 'GET') {
        // GET 请求，将文件 URL 作为查询参数
        request = axios.get(`${requestUrl}?url=${encodeURIComponent(fileUrl)}`, config);
    } else if (method.toUpperCase() === 'POST') {
        // POST 请求，将文件 URL 作为 body 发送
        request = axios.post(requestUrl, { url: fileUrl }, config);
    } else {
        console.error('不支持的请求方法:', method);
        return;
    }

    // 发送请求并处理下载
    request
        .then(res => {
            // 创建 a 标签
            const link = document.createElement("a");
            link.download = filename; // 解析后的文件名
            link.href = URL.createObjectURL(res.data);
            link.style.display = "none";

            // 触发下载
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch(err => {
            console.error('文件下载失败:', err);
        });
};
